import { Mail } from "lucide-react";
import { useTranslate } from "ra-core";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

import type { MailCard } from "../providers/vv/dataProvider";
import { MailComposer } from "./MailComposer";
import { MailTimeline, type MailFilter } from "./MailTimeline";

const filterOf = (card: MailCard): MailFilter =>
  "dealId" in card
    ? { deal_id: card.dealId }
    : "leadId" in card
      ? { lead_id: card.leadId }
      : { contact_id: card.contactId };

/** «Написать письмо» for a card. */
export const WriteMailButton = ({
  card,
  defaultTo,
  className,
}: {
  card: MailCard;
  defaultTo?: string | null;
  className?: string;
}) => {
  const translate = useTranslate();
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className={className}
        onClick={() => setOpen(true)}
      >
        <Mail className="size-4" />
        {translate("crm.mail.write")}
      </Button>
      {open ? (
        <MailComposer
          open={open}
          onOpenChange={setOpen}
          card={card}
          defaultTo={defaultTo}
        />
      ) : null}
    </>
  );
};

/** «Письма» of a card: the button and the feed. */
export const MailSection = ({
  card,
  defaultTo,
  className,
  title = true,
}: {
  card: MailCard;
  defaultTo?: string | null;
  className?: string;
  /** off when the place already has a heading (a tab, an aside section) */
  title?: boolean;
}) => {
  const translate = useTranslate();
  return (
    <section className={cn("flex flex-col gap-2 min-w-0", className)}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        {title ? (
          <h3 className="font-medium">{translate("crm.mail.title")}</h3>
        ) : null}
        <WriteMailButton card={card} defaultTo={defaultTo} />
      </div>
      <MailTimeline filter={filterOf(card)} />
    </section>
  );
};
